.chevron {
  margin-left: auto;

  [aria-expanded="true"] & {
    transform: rotate(180deg);
  }
}

.sub {
  padding-left: 1.5rem;
  background-color: rgba(0, 0, 0, 0.0125);
}
